import LucideIcon from '@/components/ui/LucideIcon';

export interface SalePoint {
  title: string;
  subtitle: string;
  icon?: React.ReactNode;
}

export const salePoints: SalePoint[] = [
  {
    title: '#1',
    subtitle: 'Destination for\nKorean Skincare',
  },
  {
    title: '100%',
    subtitle: 'Authenticity Guarantee',
  },
  {
    title: '',
    subtitle: 'Recommendations by\nSkinSight AI™',
    icon: <LucideIcon name="Sparkles" boxSize={8} color="common.100" />,
  },
  {
    title: '',
    subtitle: 'Lowest Pricing',
    icon: <LucideIcon name="PercentCircle" boxSize={8} color="common.100" />,
  },
];
